export const url = 'https://stage-sie-i0201.influensernatural.com/';
// export const url = 'https://tester-sie-i0201.influensernatural.com/';
// export const url = 'http://192.168.68.150:8900/';

